import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ContactHero from "./components/ContactHero";
import ContactForm from "./components/ContactForm";
import ContactDetails from "./components/ContactDetails";
import ContactMap from "./components/ContactMap";
import ContactClosingCTA from "./components/ContactClosingCTA";

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ContactHero />
        <ContactForm />
        <ContactDetails />
        <ContactMap />
        <ContactClosingCTA />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
